import React from 'react';
import { ClientPhotoPurpose } from '@common/model/client/photo/purpose';
import { AdminClientProfileViewModel } from '@common/model/client/profile/adminClientProfileViewModel';
import { useModalPromise } from '@cp/shared/modal';
import { AsyncResult, Result } from '@youhelp-ru/core';
import { CLIENT_PHOTO_PICK_MODAL } from '../lib/modals';

export const useClientPhotoEditingCreator = (): ((p: {
  clientProfile?: AdminClientProfileViewModel;
  purpose: ClientPhotoPurpose;
}) => AsyncResult<void, Error>) => {
  const openModal = useModalPromise(CLIENT_PHOTO_PICK_MODAL);

  return React.useCallback(
    ({ clientProfile, purpose }: { clientProfile?: AdminClientProfileViewModel; purpose: ClientPhotoPurpose }) => {
      if (!clientProfile) {
        return Promise.resolve(Result.Err(new Error('Not client profile')));
      }
      return Result.fromAsync(
        () => openModal({ clientProfile, purpose }),
        (err) => (err instanceof Error ? err : new Error('Unknown error', { cause: err })),
      );
    },
    [openModal],
  );
};
